<!--

 -->

<template>
  <div class="gsl-hrm-login-layout">
    <div class="gsl-hrm-login-layout-blob">
      <div class="gsl-hrm-login-container">
        <div class="gsl-hrm-login-slot-wrapper">
          <login-branding
            :img-src="loginBannerSrc"
            :wall="wall"
          ></login-branding>
          <div class="gsl-hrm-login-slot">
            <!-- <div class="gsl-hrm-login-logo-mobile">
              <img :src="loginLogoSrc" alt="gsl-hrm-logo" />
            </div> -->
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginBranding from './LoginBranding';

export default {
  name: 'LoginLayout',
  components: {
    'login-branding': LoginBranding,
  },
  props: {
    // loginLogoSrc: {
    //   type: String,
    //   required: false,
    // },
    loginBannerSrc: {
      type: String,
      required: true,
    },
    wall: {
      type: String,
      required: true,
    },
  },
};
</script>

<style src="./login-layout.scss" lang="scss" scoped></style>
